const projectActions = {
  FETCH_PROJECT_START: 'FETCH_PROJECT_START',
  FETCH_PROJECT_DONE: 'FETCH_PROJECT_DONE',
  FETCH_PROJECT_ERROR: 'FETCH_PROJECT_ERROR',
  FETCH_PROJECT_CANCELLED: 'FETCH_PROJECT_CANCELLED',
  FETCH_PROJECT_DENIED: 'FETCH_PROJECT_DENIED',
  FETCH_PROJECT_NOT_VISIBLE: 'FETCH_PROJECT_NOT_VISIBLE',

  FETCH_PROJECT_PPP_START: 'FETCH_PROJECT_PPP_START',
  FETCH_PROJECT_PPP_DONE: 'FETCH_PROJECT_PPP_DONE',
  FETCH_PROJECT_PPP_ERROR: 'FETCH_PROJECT_PPP_ERROR',
  FETCH_PROJECT_PPP_CANCELLED: 'FETCH_PROJECT_PPP_CANCELLED',

  FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_START: 'FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_START',
  FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_DONE: 'FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_DONE',
  FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_ERROR: 'FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_ERROR',
  FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_CANCELLED:
    'FETCH_PROJECT_PPP_LOCKED_APPLICATIONS_CANCELLED',

  RESET_PROJECT_PPP: 'RESET_PROJECT_PPP',

  INCLUDE_IN_BULK: 'INCLUDE_IN_BULK',

  /** application filters  */
  APPLICATION_FILTER_FETCH: 'APPLICATION_FILTER_FETCH',
  APPLICATION_FILTER_FETCHING_DONE: 'APPLICATION_FILTER_FETCHING_DONE',
  APPLICATION_FILTER_FETCHING_ERROR: 'APPLICATION_FILTER_FETCHING_ERROR',
  APPLICATION_FILTER_FETCHING_CANCELLED: 'APPLICATION_FILTER_FETCHING_CANCELLED',
  APPLICATION_FILTER_CLEAR: 'APPLICATION_FILTER_CLEAR',

  SET_SORT: 'SET_SORT',
  SET_FILTER: 'SET_FILTER',
  RESET_FILTER: 'RESET_FILTER',

  RESET_SELECTED_JOB: 'RESET_SELECTED_JOB',

  EXPAND_APPLICATIONS_LIST: 'EXPAND_APPLICATIONS_LIST',
  COLLAPSE_APPLICATIONS_LIST: 'COLLAPSE_APPLICATIONS_LIST',
  HIDE_APPLICATIONS_LIST: 'HIDE_APPLICATIONS_LIST',
  SHOW_APPLICATIONS_LIST: 'SHOW_APPLICATIONS_LIST',

  RESET_APPLICATION_SELECTION: 'RESET_APPLICATION_SELECTION',

  TOGGLE_BULK_ACTIONS: 'TOGGLE_BULK_ACTIONS',

  MODIFY_APPLICATION_SELECTION: 'MODIFY_APPLICATION_SELECTION',
  SELECT_MULTIPLE_APPLICATIONS: 'SELECT_MULTIPLE_APPLICATIONS',
  SELECT_ALL_APPLICATIONS: 'SELECT_ALL_APPLICATIONS',

  /** rejection */
  UPDATE_REJECTED_APPLICATIONS: 'UPDATE_REJECTED_APPLICATIONS',

  TOGGLE_SHOW_HIDDEN: 'TOGGLE_SHOW_HIDDEN',

  TOGGLE_SELECTION_LABEL_EDITOR: 'TOGGLE_SELECTION_LABEL_EDITOR',
  CHANGE_SELECTION_LABEL_TEXT: 'CHANGE_SELECTION_LABEL_TEXT',
  CHANGE_SELECTION_LABEL_VISIBLITY: 'CHANGE_SELECTION_LABEL_VISIBLITY',

  SAVE_CUSTOM_SELECTION_LABELS_START: 'SAVE_CUSTOM_SELECTION_LABELS_START',
  SAVE_CUSTOM_SELECTION_LABELS_DONE: 'SAVE_CUSTOM_SELECTION_LABELS_DONE',
  SAVE_CUSTOM_SELECTION_LABELS_ERROR: 'SAVE_CUSTOM_SELECTION_LABELS_ERROR',
  SAVE_CUSTOM_SELECTION_LABELS_CANCELLED: 'SAVE_CUSTOM_SELECTION_LABELS_CANCELLED',

  FETCH_SELECTION_LEVEL_CONFIG_START: 'FETCH_SELECTION_LEVEL_CONFIG_START',
  FETCH_SELECTION_LEVEL_CONFIG_DONE: 'FETCH_SELECTION_LEVEL_CONFIG_DONE',
  FETCH_SELECTION_LEVEL_CONFIG_ERROR: 'FETCH_SELECTION_LEVEL_CONFIG_ERROR',

  APPLICATION_RELEVANCE_REFRESH_START: 'APPLICATION_RELEVANCE_REFRESH_START',
  APPLICATION_RELEVANCE_REFRESH_DONE: 'APPLICATION_RELEVANCE_REFRESH_DONE',
  APPLICATION_RELEVANCE_REFRESH_ERROR: 'APPLICATION_RELEVANCE_REFRESH_ERROR',
  APPLICATION_RELEVANCE_REFRESH_CANCELLED: 'APPLICATION_RELEVANCE_REFRESH_CANCELLED',
  PROJECT_SMART_SORT_PROCESSING_REFETCH_DONE: 'PROJECT_SMART_SORT_PROCESSING_REFETCH_DONE',

  TOGGLE_CANDIDATE_PROFILE_UNLOCKING: 'TOGGLE_CANDIDATE_PROFILE_UNLOCKING',

  SET_BULK_TARGET: 'SET_BULK_TARGET',

  SET_STATUS_TARGET: 'SET_STATUS_TARGET',
  SET_STATUS_MENU_AUTO_OPEN: 'SET_STATUS_MENU_AUTO_OPEN',
  SET_VIEW_SWITCH_HIGHLIGHT: 'SET_VIEW_SWITCH_HIGHLIGHT',
  SET_CALENDAR_TOUR_TARGET: 'SET_CALENDAR_TOUR_TARGET',

  SET_FILTER_DIRTINESS: 'SET_FILTER_DIRTINESS',

  fetchProject: (variables: any, recache: Boolean) => ({
    type: projectActions.FETCH_PROJECT_START,
    payload: {
      variables,
      recache,
    },
  }),

  fetchProjectPPP: (projectId: number) => ({
    type: projectActions.FETCH_PROJECT_PPP_START,
    payload: {
      projectId,
    },
  }),

  resetProjectPPP: () => ({
    type: projectActions.RESET_PROJECT_PPP,
  }),

  includeInBulk: (applicationId: number) => ({
    type: projectActions.INCLUDE_IN_BULK,
    payload: {
      applicationId,
    },
  }),

  clearApplicationFilters: () => ({
    type: projectActions.APPLICATION_FILTER_CLEAR,
  }),

  fetchApplicationFilters: (projectId: number) => ({
    type: projectActions.APPLICATION_FILTER_FETCH,
    payload: projectId,
  }),

  setFilter: (payload: any) => ({
    type: projectActions.SET_FILTER,
    payload,
  }),

  resetFilter: (payload: any) => ({
    type: projectActions.RESET_FILTER,
    payload,
  }),

  resetSelectedJob: (payload: any) => ({
    type: projectActions.RESET_SELECTED_JOB,
    payload,
  }),

  expandApplicationList: () => ({
    type: projectActions.EXPAND_APPLICATIONS_LIST,
  }),

  collapseApplicationList: () => ({
    type: projectActions.COLLAPSE_APPLICATIONS_LIST,
  }),

  hideApplicationsList: () => ({
    type: projectActions.HIDE_APPLICATIONS_LIST,
  }),

  showApplicationList: () => ({
    type: projectActions.SHOW_APPLICATIONS_LIST,
  }),

  resetApplicationToSelection: () => ({
    type: projectActions.RESET_APPLICATION_SELECTION,
  }),

  /** there saga connected to this action */
  setSort: (payload: any) => ({
    type: projectActions.SET_SORT,
    payload,
  }),

  toggleBulkActions: (state: Boolean) => ({
    type: projectActions.TOGGLE_BULK_ACTIONS,
    payload: {
      state,
    },
  }),

  setApplicationToSelection: (payload: any) => ({
    type: projectActions.MODIFY_APPLICATION_SELECTION,
    payload,
  }),

  selectMultipleApplications: (payload: any) => ({
    type: projectActions.SELECT_MULTIPLE_APPLICATIONS,
    payload,
  }),

  selectAllApplications: () => ({
    type: projectActions.SELECT_ALL_APPLICATIONS,
  }),

  toggleShowHidden: (payload: any) => ({
    type: projectActions.TOGGLE_SHOW_HIDDEN,
    payload,
  }),

  saveCustomSelectionLabels: (payload: any) => ({
    type: projectActions.SAVE_CUSTOM_SELECTION_LABELS_START,
    payload,
  }),

  changeSelectionLabelVisibility: (payload: any) => ({
    type: projectActions.CHANGE_SELECTION_LABEL_VISIBLITY,
    payload,
  }),

  changeSelectionLabelText: (payload: any) => ({
    type: projectActions.CHANGE_SELECTION_LABEL_TEXT,
    payload,
  }),

  toggleSelectionLabelEditor: (state: Boolean) => ({
    type: projectActions.TOGGLE_SELECTION_LABEL_EDITOR,
    payload: state,
  }),

  toggleCandidateProfileUnlocking: (state: number) => ({
    type: projectActions.TOGGLE_CANDIDATE_PROFILE_UNLOCKING,
    payload: state,
  }),

  setBulkTarget: (payload: any) => ({
    type: projectActions.SET_BULK_TARGET,
    payload,
  }),

  setStatusTarget: (payload: any) => ({
    type: projectActions.SET_STATUS_TARGET,
    payload,
  }),

  /** Opens one row's selection-level dropdown from the outside; `key` is the row index, null clears. */
  setStatusMenuAutoOpen: (payload: { key: number | null }) => ({
    type: projectActions.SET_STATUS_MENU_AUTO_OPEN,
    payload,
  }),

  /** Rings the list/columns view switch after the onboarding, to point at what it just described. */
  setViewSwitchHighlight: (payload: { active: boolean }) => ({
    type: projectActions.SET_VIEW_SWITCH_HIGHLIGHT,
    payload,
  }),

  setCalendarTourTarget: (payload: any) => ({
    type: projectActions.SET_CALENDAR_TOUR_TARGET,
    payload,
  }),

  setFilterDirtiness: (payload: boolean) => ({
    type: projectActions.SET_FILTER_DIRTINESS,
    payload,
  }),
};

export default projectActions;
